// extracted by mini-css-extract-plugin
export default {"circleContainer":"NavigationCircles_circleContainer__TkKMT"};